module.exports = __webpack_public_path__ + "static/media/new-twistedroad-logo.848748f2.webp";